const SelfServeBuilderSidePanelConstants = {
  SET_IS_OPEN: 'SELF_SERVE_BUILDER_SIDE_PANEL_IS_OPEN_SET',
  DEFAULT_OPEN_PANEL_WIDTH: 340,
  DEFAULT_CLOSE_PANEL_WIDTH: 40,
};

export const SelfServeBuilderSidePanelTypes = {
  POST_BUILDER: 'SELF_SERVE_POST_BUILDER_SIDE_PANEL',
  TOOLBOX: 'SELF_SERVE_BUILDER_TOOLBOX_SIDE_PANEL',
};

export default SelfServeBuilderSidePanelConstants;



// WEBPACK FOOTER //
// ./src-react/SelfServeBuilderSidePanel/SelfServeBuilderSidePanelConstants.jsx